import React, {useCallback, useContext, useEffect, useRef, useState,} from "react";
import useFetch, {CachePolicies} from "use-http";
import {useTranslation} from "react-i18next";
import moment from "moment";
import socket from "socket.io-client";
import _ from "lodash";
import {message, Modal, notification} from "antd";
import styles from "./ChatContentTab.module.scss";
import {getToken} from "../../../service/auth.service";
import {AppContext} from "../../context/App.context";
import {QuickChatContext} from "../../context/QuickChat.context";
import UIChatSkeleton from "./UIChatSkeleton";
import UIChatToolbar from "./UIChatToolbar";
import UIMessage from "./UIMessage";
import UIChatModalViewFile from "./UIChatModalViewFile";
import UIMessageControl from "./UIMessageControl";
import UINotiNewMessage from "./UINotiNewMessage";
import UIBottomButton from "./UIBottomButton";
import UIForwardMessages from "./UIForwardMessages";
import {getChatDB} from "../../../db/chat.db";
import {
    expAudio,
    expImgges,
    expVideo,
    limitDateStorage,
    limitForward,
    limitLoadMessage,
    limitSliceMessage,
    messageTypes,
    sendStatus,
    Service,
} from "./ChatConstants";
import {checkEmpty} from "src/service/util.service";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";
import {v4 as uuidv4} from "uuid";
import {getClassAndType, getFinalNameChat} from "src/service/files.util";
import {chunkSize, uploadFileRequestChunkChat,} from "src/service/files.service";
import axios from "axios";
import {useAppSelector} from "src/hooks";
import {profile} from "src/features/profile/profileSlice";

const ChatDB = getChatDB();

function handleMember(members: any) {
  let tempMember: any = [];
  const loopMember: any = members;
  for (let item of loopMember) {
    tempMember = [
      ...tempMember,
      Object.assign({
        userId: item?.userID,
        name: item?.user?.firstname || item?.user?.username,
        link: item?.userID,
        user: {
          username: item?.user?.firstname || item?.user?.username,
          profile: item?.user?.imageProfileURL,
        },
      }),
    ];
  }
  return tempMember;
}

const getAuthorization = () => {
  let token = getToken();
  let authorization = "Bearer " + token;

  return authorization;
};

function create_UUID() {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
  );
  return uuid;
}

const ChatContentTab = (props: any) => {
  const appContext: any = useContext(AppContext);
  const myProfile = useAppSelector(profile)
  // let userObj: any = Auth?.getUserData();
  // let userObj: any = appContext?.profile;
  var toDay: any = moment().format();
  const quickChatCtx: any = useContext(QuickChatContext);
  const [isNewChat, setNewChat] = useState(props?.group?.isNewChat || false);
  const { navigator, onClickGroup } = props;
  const { t } = useTranslation();
  const currentUserId: string = myProfile.id; //'userIdtest' ;
  const members = props?.group?.members;
  const currentGroupId: string = props?.group?.id; //  'groupIdtest'
  const [IsSocketError, setSocketError]: any = useState(false);
  const [storageMessageList, setStorageMessageList]: any = useState([]);
  const [messageList, setMessageList]: any = useState([]);
  const [newMessageList, setNewMessageList]: any = useState([]);
  const [notiMessage, setNotiMessage]: any = useState({});
  const [scrollDirection, setScrollDirection]: any = useState([]);
  const [isOpenControl, setOpenControl]: any = useState({ isOpen: false });
  const [isPageActive, setPageActive]: any = useState({ isOpen: false });
  const [isSelect, setSelect]: any = useState({ select: false });
  const [isLoadingData, setLoadingData]: any = useState(false);
  const [isOpenSticker, setOpenSticker]: any = useState(false);
  const [isOpenForward, setOpenForward]: any = useState({ isOpen: false });
  const [isOpenRecordAudio, setOpenRecordAudio]: any = useState(false);
  const [dataPreviewFile, setDataPreviewFile]: any = useState({});
  const [scrollPosition, setScrollPosition]: any = useState(0);
  const [loadingData, setLoading]: any = useState(false);
  const [isPreviewFile, setPreviewFile]: any = useState(false);
  const [isReply, setReply]: any = useState(false);
  const [countSelect, setCountSelect]: any = useState(0);
  const [isOldTop, setOldTop]: any = useState(false);
  const [isPullHook, setIsPullHook]: any = useState(false);
  const [isBlockSelect, setBlockSelect]: any = useState(false);
  const [showDeleteModal, setShowDeleteModal]: any = useState(false);
  const [showUnsendModal, setShowUnsendModal]: any = useState(false);
  const [messageSelected, setMessageSelected]: any = useState(null);
  const [memberData, setMemberData] = useState([]);
  const [sliceLength, setSliceLength] = useState(0);
  const [uploadProgress, setUploadProgress]: any = useState([]);
  const [isGroupCommunity, setIsGroupCommunity] = useState(
    checkEmpty(props.isGroupCommunity) ? false : props.isGroupCommunity
  );
  const [searchingReplyFuncCheck, setSearchingReplyFuncRunCheck]: any = useState(false);
  const serverUrl: any = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE;
  //@ts-ignore
  const refNewMessage: React.MutableRefObject<HTMLDivElement> = useRef(null);
  //@ts-ignore
  const chatView: React.MutableRefObject<HTMLDivElement> = useRef(null);
  //@ts-ignore
  const refControl: React.MutableRefObject<HTMLDivElement> = useRef(null);
  let dateBlk: string = "";
  let storageKey: string = currentUserId + "_" + currentGroupId;
  const [heightQuickChat, setHeightQuickChat]: any = useState(
    props?.isQuickChat
      ? "calc(100vh - 396px) !important"
      : props?.liveChat
      ? "calc(100vh - 64px)"
      : props.conferenceChat
      ? "calc(100vh - 215px)"
      : "calc(100vh - 215px)"
  );
  const { confirm } = Modal;
  const lang = localStorage.getItem("lang");
  const {warning} = Modal;
  const [loadingFile, setLoadingFile] = useState(false);

  const apiSaveReadMessage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveReadMessage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiFindMessage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatFindMessage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiSaveMessage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveMessage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiUnsendMessage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatUnsendMessage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiDeleteMessage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveTransactionMessage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiFindMessageUpdate = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatFindMessageUpdate,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiFindMessageNew = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatFindMessageNew,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiDeleteFile = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + Service.FileSreviceDeleteFile,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiSaveMessageImage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveMessageImage,
    {
        method: "post",
        cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  useEffect(() => {
    if (members?.length > 0) {
      setMemberData(handleMember(members));
    }
  }, [members]);

  useEffect(() => {
    if (IsSocketError) {
      showToast();
    }
  }, [IsSocketError]);

  var showToast = function () {
    //@ts-ignore
    if (IsSocketError) {
      notification.warning({
        message: "[Chat] Cannot connect to the server.",
        placement: "topRight",
      });
    } else {
      notification.success({
        message: "[Chat] Connect to the server success.",
        placement: "topRight",
      });
    }
  };

  const updateStorage = async (
    newMessageList: any,
    messageList: any,
    storageMessageList: any,
    status: any
  ) => {
    let count = 0;
    const messageData = await _.uniqBy(
      _.sortBy(_.concat(newMessageList, messageList), [
        "messageTime",
      ])?.reverse?.(),
      "messageId"
    );
    if (status) {
      await _.uniqBy(
        messageData?.filter?.((item: any) =>
          item?.messageURLlocal ? delete item["messageURLlocal"] : item
        ),
        "messageId"
      );
      await _.uniqBy(
        messageData?.filter?.((item: any) =>
          item?.messageRefId ? delete item["messageRefId"] : item
        ),
        "messageId"
      );
    }
    //@ts-ignore
    count = await ChatDB?.chat_message.where({ id: storageKey }).count();
    if (count < 1) {
      //@ts-ignore
      await ChatDB?.chat_message.put({
        id: storageKey,
        data: _.uniqBy(messageData, "messageId"),
      });
      return;
    }
    if (storageMessageList?.length === 0) {
      //@ts-ignore
      await ChatDB?.chat_message.update(storageKey, { data: messageData });
      return;
    }
    //@ts-ignore
    await ChatDB.chat_message.update(storageKey, {
      data: _.uniqBy(messageData?.concat(storageMessageList), "messageId"),
    });
  };

  const updateStorageLeaveGroup = async (currentGroupId: string) => {
    //@ts-ignore
    let count = await ChatDB?.chat_message.where({ id: storageKey }).count();
    if (count > 0) {
      //@ts-ignore
      await ChatDB?.chat_message.delete(currentUserId + "_" + currentGroupId);
      return;
    }
  };

  const hendleSaveReadMessage = async () => {
    let responseData;
    let msgBody = {};
    msgBody = {
      groupId: currentGroupId,
    };
    responseData = await apiSaveReadMessage.post(msgBody);
    if (
      typeof onClickGroup === "function" &&
      responseData?.message === "Updated" &&
      responseData?.status === "Success"
    ) {
      onClickGroup();
    }
  };

  const handleUpdateNewMessage = useCallback(async () => {
    try {
      if (isNewChat) {
        setLoading(false);
        updateStorage([], [], [], false);
        setMessageList([]);
        setNewMessageList([]);
        setStorageMessageList([]);
        console.log("New group Chat");
        return;
      }
      let msgBody = {};
      let responseData: any;
      let messageStorage: any;
      let messageNew: any;
      let isOutdatedData: boolean = false;
      console.log("Start handleUpdateNewMessage");
      //@ts-ignore
      await ChatDB.chat_message
        .where({ id: storageKey })
        .first((messages: any) => {
          messageStorage = messages?.data?.filter(
            (item: any) =>
              item?.messageStatus?.toLowerCase() !==
              sendStatus?.Sending.toLowerCase()
          );
        })
        .catch((error: any) => {
          console.error(error.stack || error);
        });
      if (messageStorage) {
        await messageStorage?.filter?.(
          (item: any) => item?.groupId !== currentGroupId
        );
      }
      if (messageStorage) {
        setLoading(false);
        await messageStorage?.filter?.((item: any) =>
          item?.messageURLlocal
            ? delete item["messageURLlocal"]
            : item?.messageRefId
            ? delete item["messageRefId"]
            : item
        );
        messageStorage = await _.sortBy(messageStorage, [
          "messageTime",
        ])?.reverse?.();
        var nowDate: any = new Date();
        var diffDate: any = moment.duration(
          moment(nowDate).diff(moment(messageStorage?.[0]?.messageTime))
        ); //moment.duration(nowDate.diff(messageStorage?.[0]?.messageTime));
        if (
          messageStorage?.[0]?.messageTime &&
          parseInt(diffDate.asDays()) < limitDateStorage
        ) {
          console.log("[Chat] Lessthan 2Days");
          //@ts-ignore
          await setStorageMessageList(_.uniqBy(messageStorage, "messageId"));
          if (messageStorage?.length > 30) {
            //@ts-ignore
            setMessageList(_.uniqBy(messageStorage?.slice(0, 15), "messageId"));
            setSliceLength(15);
          } else {
            //@ts-ignore
            setMessageList(_.uniqBy(messageStorage, "messageId"));
            setSliceLength(messageStorage?.length);
          }
        } else {
          console.log("[Chat] Max Diff Over 2Days");
          setLoading(true);
          messageStorage = null;
          isOutdatedData = true;
        }
      } else {
        console.log("[Chat] No message in storage");
        isOutdatedData = true;
        setLoading(true);
      }
      console.log("[Chat] ", isOutdatedData, !messageStorage);
      //TODO remove it when everything test pass
      msgBody = {
        groupId: currentGroupId,
        messageTime: new Date(),
        messageNumber: limitLoadMessage,
      };
      responseData = await apiFindMessage.post(msgBody);
      if (
        responseData?.status?.toLowerCase() ===
        sendStatus?.Success?.toLowerCase()
      ) {
        setLoading(false);
        messageNew = responseData?.objData || [];
        if (!messageStorage && messageNew?.length === 0) {
          await hendleSaveReadMessage();
          updateStorage([], [], [], false);
          return;
        }
        if (!messageStorage && messageNew?.length > 0) {
          await hendleSaveReadMessage();
          setMessageList(messageNew);
          return;
        }
        await hendleSaveReadMessage();
        //@ts-ignore
        await setMessageList((prevState) =>
          _.sortBy(_.uniqBy(_.concat(messageNew, prevState), "messageId"), [
            "messageTime",
          ])?.reverse?.()
        );
        //@ts-ignore
        await setStorageMessageList((prevState) =>
          _.sortBy(_.uniqBy(_.concat(messageNew, prevState), "messageId"), [
            "messageTime",
          ])?.reverse?.()
        );
        handleUpdateStorageMessage(
          messageStorage?.[messageStorage?.length - 1]?.messageTime
        );
      } else {
        console.error("[Find Message Error]: ", responseData);
        setLoading(false);
      }
    } catch (error) {
      console.warn("Error handleUpdateNewMessage : ", error);
    }
  }, [currentGroupId]);

  const handleUpdateStorageMessage = async (messageTime: any) => {
    let responseData: any;
    let msgBody: object = {
      groupId: currentGroupId,
      messageTime: messageTime,
    };
    console.log("[Chat] UpdateStorageMessage : ", messageTime);
    try {
      responseData = await apiFindMessageUpdate.post(msgBody);
      if (
        responseData?.status?.toLowerCase() ===
        sendStatus?.Success?.toLowerCase()
      ) {
        const resultDelete = responseData?.objData?.resultDelete;
        const resultUnsend = responseData?.objData?.resultUnsend;
        //@ts-ignore
        await setMessageList((prevState) =>
          prevState.filter(
            //@ts-ignore
            ({ messageId: id1 }) =>
              //@ts-ignore
              !resultDelete.some(({ messageId: id2 }) => id2 === id1)
          )
        );
        //@ts-ignore
        await setStorageMessageList((prevState) =>
          prevState.filter(
            //@ts-ignore
            ({ messageId: id1 }) =>
              //@ts-ignore
              !resultDelete.some(({ messageId: id2 }) => id2 === id1)
          )
        );
        for (let index = 0; index < resultUnsend?.length; index++) {
          const element = resultUnsend[index];
          //@ts-ignore
          await setMessageList((prevState: any) =>
            prevState.map((item: any) =>
              item?.messageId === element?.messageId
                ? Object.assign({}, item, {
                    messageStatus: sendStatus.Unsend,
                  })
                : item
            )
          );
          //@ts-ignore
          await setStorageMessageList((prevState: any) =>
            prevState.map((item: any) =>
              item?.messageId === element?.messageId
                ? Object.assign({}, item, {
                    messageStatus: sendStatus.Unsend,
                  })
                : item
            )
          );
        }
      }
    } catch (error) {
      console.warn("[Chat Error] handleUpdateStorageMessage : ", error);
    }
  };

  useEffect(() => {
    console.log("[Chat] loading data from server only first time to see");
    setLoading(true);
    setOpenSticker(false);
    setMessageList([]);
    setNewMessageList([]);
    setStorageMessageList([]);
    setScrollDirection([]);
    setOpenControl({ isOpen: false });
    setPageActive({ isOpen: false });
    setSelect({ select: false });
    setLoadingData(false);
    setDataPreviewFile({});
    setScrollPosition(0);
    setPreviewFile(false);
    setReply(false);
    setCountSelect(0);
    setOldTop(false);
    setIsPullHook(false);
    setBlockSelect(false);
    setSliceLength(0);
    setSocketError(false);
    if (currentGroupId) {
      handleUpdateNewMessage();
    }
    return () => {
      console.log("[Chat] when an mount abort() API");
      apiFindMessage.abort();
      apiFindMessageNew.abort();
      apiSaveReadMessage.abort();
    };
  }, [currentGroupId]);

  useEffect(() => {
    let isSubscribed = true;
    let serverUrlTemp = serverUrl;
    let serverUrlPath: any = "";
    let path: any = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT;
    if (serverUrlTemp.indexOf(path) != -1) {
      serverUrlTemp = serverUrl.replace(
        window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT,
        ""
      );
      serverUrlPath = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT;
    }
    let client = socket.connect(serverUrlTemp, {
      path: serverUrlPath + "/socket.io",
      forceNew: true,
    });
    const handleUpdateMessageList = (newMessage: any) => {
      console.log("handleUpdateMessageList newMessage ::", newMessage);
      if (newMessage?.objData[0]?.messageType === messageTypes.LeaveGroup) {
        updateStorageLeaveGroup(currentGroupId);
        setMessageList([]);
        setNewMessageList([]);
        setStorageMessageList([]);
        props.onBackMainChat(null);
        return;
      }
      //@ts-ignore
      setNewMessageList((prevState: any) => {
        if (
          newMessage?.objData[0]?.messageRefId &&
          prevState.filter(
            (item: any) =>
              item?.messageRefId === newMessage?.objData[0]?.messageRefId
          )?.length > 0
        ) {
          console.log("[Chat] socket update");
          if (newMessage?.objData[0]?.messageType === messageTypes.Image) {
            // console.log("socket update: ",newMessage?.objData[0]?.stampUpload);
            return _.uniqBy(
              _.sortBy(
                prevState.map((item: any) =>
                  item?.messageRefId === newMessage?.objData[0]?.messageRefId
                    ? Object.assign({}, item, {
                        messageStatus:
                          newMessage?.objData[0]?.stampUpload > 0
                            ? "created"
                            : "sending",
                        messageId: newMessage?.objData[0]?.messageId,
                        messageTime: newMessage?.objData[0]?.messageTime,
                        messageDetails:
                          newMessage?.objData[0]?.messageDetails || [],
                        messageURLlocal:
                          item?.messageType === messageTypes.Image ||
                          item?.messageType === messageTypes.Video
                            ? item?.messageDetails
                            : {},
                        mentionProperty: newMessage?.objData[0]?.mentionProperty
                      })
                    : item
                ),
                ["messageTime"]
              )?.reverse(),
              "messageId"
            );
          }
          return _.uniqBy(
            _.sortBy(
              prevState.map((item: any) =>
                item?.messageRefId === newMessage?.objData[0]?.messageRefId
                  ? Object.assign({}, item, {
                      messageStatus: "created",
                      messageId: newMessage?.objData[0]?.messageId,
                      messageTime: newMessage?.objData[0]?.messageTime,
                      messageDetails:
                        newMessage?.objData[0]?.messageDetails || [],
                      messageURLlocal:
                        item?.messageType === messageTypes.Image ||
                        item?.messageType === messageTypes.Video
                          ? item?.messageDetails
                          : {},
                      mentionProperty: newMessage?.objData[0]?.mentionProperty
                    })
                  : item
              ),
              ["messageTime"]
            )?.reverse(),
            "messageId"
          );
        } else {
          console.log("[Chat] socket put");
          hendleSaveReadMessage();
          return _.uniqBy(
            _.sortBy(_.concat(newMessage?.objData, prevState), [
              "messageTime",
            ])?.reverse?.(),
            "messageId"
          );
        }
      });
    };
    //================ handleUpdateUnsendMessageLise ================
    const handleUpdateUnsendMessageList = (newMessage: any) => {
      //@ts-ignore
      setNewMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus: sendStatus.Unsend,
                })
              : newMessage?.objData[0]?.messageId === item?.messageReplyId
              ? Object.assign({}, item, {
                  messageReplyDetails: [],
                  messageDetails: {},
                })
              : item
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus: sendStatus.Unsend,
                })
              : newMessage?.objData[0]?.messageId === item?.messageReplyId
              ? Object.assign({}, item, {
                  messageReplyDetails: [],
                  messageDetails: {},
                })
              : item
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setStorageMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus: sendStatus.Unsend,
                })
              : newMessage?.objData[0]?.messageId === item?.messageReplyId
              ? Object.assign({}, item, {
                  messageReplyDetails: [],
                  messageDetails: {},
                })
              : item
          ),
          "messageId"
        )
      );
    };
    //================ handleUpdateUnsendMessageLise ================
    const handleUpdateDeleteMessageList = (newMessage: any) => {
      //@ts-ignore
      setNewMessageList((prevState: any) =>
        _.uniqBy(
          prevState.filter(
            (item: any) => item?.messageId !== newMessage?.objData[0]?.messageId
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setMessageList((prevState: any) =>
        _.uniqBy(
          prevState.filter(
            (item: any) => item?.messageId !== newMessage?.objData[0]?.messageId
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setStorageMessageList((prevState: any) =>
        _.uniqBy(
          prevState.filter(
            (item: any) => item?.messageId !== newMessage?.objData[0]?.messageId
          ),
          "messageId"
        )
      );
    };
    //================ handleUpdateMessageNewImage ================
    const handleUpdateMessageNewImage = (newMessage: any) => {
      console.log("[Chat] handleUpdateMessageNewImage");
      //@ts-ignore
      setNewMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData?.[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus:
                    item?.messageStatus === "sending" &&
                    newMessage?.objData[0]?.stampUpload < 0
                      ? "sending"
                      : "created",
                  messageDetails: newMessage?.objData?.[0]?.messageDetails,
                  stampUpload: newMessage?.objData?.[0]?.stampUpload,
                })
              : item
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData?.[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus:
                    item?.messageStatus === "sending" &&
                    newMessage?.objData[0]?.stampUpload < 0
                      ? "sending"
                      : "created",
                  messageDetails: newMessage?.objData?.[0]?.messageDetails,
                  stampUpload: newMessage?.objData?.[0]?.stampUpload,
                })
              : item
          ),
          "messageId"
        )
      );
      //@ts-ignore
      setStorageMessageList((prevState: any) =>
        _.uniqBy(
          prevState.map((item: any) =>
            item?.messageId === newMessage?.objData?.[0]?.messageId
              ? Object.assign({}, item, {
                  messageStatus:
                    item?.messageStatus === "sending" &&
                    newMessage?.objData[0]?.stampUpload < 0
                      ? "sending"
                      : "created",
                  messageDetails: newMessage?.objData?.[0]?.messageDetails,
                  stampUpload: newMessage?.objData?.[0]?.stampUpload,
                })
              : item
          ),
          "messageId"
        )
      );
    };

    //================ Socket ================
    if (currentGroupId) {
      client.on("connect", () => {
        setSocketError(false);
        client.on("messageForGroup_" + currentGroupId, (newMessage: any) => {
          console.log("[Chat] Socket New message");
          // console.log("[Chat] Socket data : ", newMessage);

          /* for ignore new message type StartingChat */
          if (
            newMessage?.objData?.[0]?.messageType === messageTypes?.StartingChat
          ) {
            return;
          }

          /* for quickchat notification */
          if (props.isQuickChat) {
            quickChatCtx?.setNewMessage(newMessage);
          }

          if (
            newMessage.message.toLowerCase() ===
            sendStatus.Updated.toLowerCase()
          ) {
            if (isSubscribed) handleUpdateMessageNewImage(newMessage);
          } else if (
            newMessage.message.toLowerCase() === sendStatus.Unsend.toLowerCase()
          ) {
            if (isSubscribed) handleUpdateUnsendMessageList(newMessage);
          } else if (
            newMessage.message.toLowerCase() ===
            sendStatus.Deleted.toLowerCase()
          ) {
            if (isSubscribed)
              if (currentUserId === newMessage?.objData[0]?.userId)
                handleUpdateDeleteMessageList(newMessage);
          } else if (
            newMessage.message.toLowerCase() ===
            sendStatus.Forward.toLowerCase()
          ) {
            if (isSubscribed) {
              //@ts-ignore
              setNewMessageList((prevState) =>
                _.uniqBy(
                  _.sortBy(_.concat(newMessage?.objData, prevState), [
                    "messageTime",
                  ])?.reverse?.(),
                  "messageId"
                )
              );
              const newList = newMessage?.objData;
              if (currentUserId !== newList?.[0]?.userId) {
                setScrollDirection({
                  //@ts-ignore
                  direct: 1,
                  event: sendStatus.New,
                  objData: newList[newList?.length - 1],
                });
              } else {
                setScrollDirection({
                  //@ts-ignore
                  direct: 1,
                  event: sendStatus.Update,
                  objData: null,
                });
              }
            }
          } else if (
            newMessage.message.toLowerCase() === sendStatus.New.toLowerCase()
          ) {
            if (isSubscribed) {
              if (
                newMessage?.objData[0]?.messageType === messageTypes?.JoinGroup
              ) {
                if (newMessage?.objData[0]?.messageDetails) {
                  let newUserDetail = newMessage?.objData[0]?.messageDetails;
                  //@ts-ignore
                  setMemberData((prevState) => [
                    ...prevState,
                    Object.assign({
                      userId: newUserDetail?.username,
                      name: newUserDetail?.firstname || newUserDetail?.username,
                      link: newUserDetail?.username,
                      user: {
                        username:
                          newUserDetail?.firstname || newUserDetail?.username,
                        profile: newUserDetail?.imageProfileURL,
                      },
                    }),
                  ]);
                }
              }
              if (currentUserId === newMessage?.objData[0]?.userId) {
                handleUpdateMessageList(newMessage);
              } else {
                if (
                  newMessage?.objData[0]?.messageType ===
                  messageTypes?.KickGroup
                ) {
                  let messageText = newMessage?.objData[0]?.messageText;
                  let lastIndex = messageText?.lastIndexOf("_");
                  let joinUserId = messageText?.substring(0, lastIndex);
                  if (joinUserId === currentUserId) {
                    updateStorageLeaveGroup(currentGroupId);
                    setMessageList([]);
                    setNewMessageList([]);
                    setStorageMessageList([]);
                    props.onBackMainChat(null);
                    return;
                  }
                }
                delete newMessage?.objData[0]?.["messageRefId"];
                //@ts-ignore
                setNewMessageList((prevState) =>
                  _.uniqBy(
                    _.sortBy(_.concat(newMessage?.objData, prevState), [
                      "messageTime",
                    ])?.reverse?.(),
                    "messageId"
                  )
                );
                setScrollDirection({
                  //@ts-ignore
                  direct: 1,
                  event: newMessage?.message,
                  objData: newMessage?.objData[0],
                });
              }
            }
          } else {
          }
        });
      });
      client.on("connect_error", (error: any) => {
        console.warn("[Chat Error] Client connection error!!");
        console.error("[Chat Error] Error message : ", error);
        setSocketError(true);
      });
      client.on("drop", (e :any) => {
        
      })
    }

    return () => {
      client.disconnect();
      setOpenSticker(false);
      setMessageList([]);
      setNewMessageList([]);
      setStorageMessageList([]);
      setScrollDirection([]);
      setOpenControl({ isOpen: false });
      setPageActive({ isOpen: false });
      setSelect({ select: false });
      setLoadingData(false);
      setDataPreviewFile({});
      setScrollPosition(0);
      setPreviewFile(false);
      setReply(false);
      setCountSelect(0);
      setOldTop(false);
      setIsPullHook(false);
      setBlockSelect(false);
      setSliceLength(0);
      setSocketError(false);
      console.log("[Chat] client.disconnect()");
      isSubscribed = false;
    };
  }, [currentGroupId]);

  useEffect(() => {
    if (newMessageList?.length > 0) {
      updateStorage(newMessageList, messageList, storageMessageList, "");
    }
    if (messageList?.length > 0) {
      updateStorage(newMessageList, messageList, storageMessageList, "");
    }
    // return () => {
    //   updateStorage(messageList, storageMessageList, true);
    // };
  }, [messageList, newMessageList]);

  const handleScrollBottom = useCallback(
    (event: string, objNew: any) => {
      // console.log("handleScrollBottom");
      if (messageList?.length < 1) return;
      if (isSelect?.select) return;
      if (notiMessage) {
        //@ts-ignore
        if (notiMessage?.notiType === sendStatus.Reply) return true;
      }
      // console.log("scrollPosition : ", scrollPosition);
      if (
        event.toLowerCase() === sendStatus.New.toLowerCase() &&
        objNew?.userId !== currentUserId &&
        chatView.current?.scrollTop < scrollPosition
      ) {
        console.log("[Chat] Show NotiOnWeb");
        setNotiMessage(objNew);
        return true;
      }
      // if (chatView.current?.scrollTop === scrollPosition) return;
      //refNewMessage?.current?.scrollIntoView?.();
      const scrollHeight: number = chatView?.current?.scrollHeight;
      chatView.current.scrollTop = scrollHeight;
      setScrollPosition(chatView.current?.scrollTop);
      if (Object.keys(notiMessage)?.length > 0) hendleSaveReadMessage();
      setNotiMessage({});
      setReply(false);
    },
    [messageList?.length, scrollPosition, currentUserId]
  );

  useEffect(() => {
    //@ts-ignore
    if (scrollDirection?.direct > 0 && !isReply) {
      //@ts-ignore
      handleScrollBottom(scrollDirection?.event, scrollDirection?.objData);
    }
  }, [scrollDirection]);

  const loadOldMessage = async () => {
    setIsPullHook(true);
    setLoadingData(true);
    try {
      console.log(`[Chat] Load old messages...`);
      if (isOldTop) {
        console.log(`[Chat] Top messages!`);
        setIsPullHook(false);
        setLoadingData(false);
      }
      if (messageList?.length < 1) {
        setIsPullHook(false);
        setLoadingData(false);
      }
      const lengthData: number = messageList?.length - 1 || 0;
      const element: any = document.getElementById(
        messageList[lengthData]?.messageId
      );
      let responseData: any = [];
      let msgBody: any = {
        userId: "null",
        groupId: currentGroupId,
        messageTime: messageList?.[lengthData]?.messageTime,
        messageNumber: limitLoadMessage + 1,
      };
      // console.log("[Chat] loadOldMessage msgBody:", msgBody);
      responseData = await apiFindMessage.post(msgBody);
      const resMessageList: any = responseData?.objData;
      const difData: any = _.differenceBy(
        resMessageList,
        messageList,
        "messageId"
      );
      if (difData?.length < 1) {
        console.log(`[Chat] Top messages!`);
        // setOldTop(true);
        setIsPullHook(false);
        setLoadingData(false);
        return;
      }
      if (resMessageList?.length > 0) {
        await setMessageList((prevState: any) =>
          _.uniqBy(_.concat(prevState, resMessageList), "messageId")
        );
        element.scrollIntoView();
        setSliceLength(
          (prevState: any) => prevState + (resMessageList?.length - 1)
        );
        console.log(`[Chat] Load old messages success.`);
        setIsPullHook(false);
        setLoadingData(false);
      }
    } catch (error) {
      console.warn("[Chat Error] Load old message : ", error);
      setIsPullHook(false);
      setLoadingData(false);
    }
  };

  //================= API Save =================
  const handleSave = async (msgBody: any) => {
    try {
      let responseData: any = await apiSaveMessage.post(msgBody);
      if (
        responseData?.status?.toLowerCase() === sendStatus.Success.toLowerCase()
      ) {
        await hendleSaveReadMessage();
        if (msgBody.messageType === messageTypes.Image) {
          return responseData?.objData?.messageId;
        }
      } else {
        //@ts-ignore
        setNewMessageList((prevState) =>
          //@ts-ignore
          prevState.map((item) =>
            //@ts-ignore
            item?.messageRefId === msgBody.refID
              ? Object.assign({}, item, {
                  messageStatus: sendStatus.SendFail,
                })
              : item
          )
        );
      }
    } catch (error) {
      //@ts-ignore
      setNewMessageList((prevState) =>
        //@ts-ignore
        prevState.map((item) =>
          //@ts-ignore
          item?.messageRefId === msgBody?.refID
            ? Object.assign({}, item, {
                messageStatus: sendStatus.SendFail,
              })
            : item
        )
      );
      console.warn("[Chat Error] handleSave sendMessage : ", error);
    }
  };

  const handleReSave = async (msgObj: any) => {
    console.log("[Chat] Resend message...");
    setNewMessageList((prevState: any) =>
      prevState.map((item: any) =>
        item?.messageRefId === msgObj?.refId
          ? Object.assign({}, item, {
              messageStatus: sendStatus.Sending,
            })
          : item
      )
    );
    try {
      const msgBody: object = {
        userId: currentUserId,
        groupId: currentGroupId,
        messageType: msgObj?.messageType,
        messageText: msgObj?.messageText,
        messageDetails: msgObj?.messageDetails || {},
        refID: msgObj?.messageId,
      };
      handleSave(msgBody);
    } catch (error) {
      console.warn("[Chat Error] HandleReSave : ", error);
    }
  };

  const handleCancelSave = (messageId: string) => {
    setNewMessageList((prevState: any) =>
      prevState.filter((item: any) => item?.messageId !== messageId)
    );
  };

  //================= Action for Forwerd or Delete =================
  const handleSubmitAction = (type: string) => {
    const checkboxes = document.querySelectorAll(
      'input[name="selectMessage"]:checked'
    );
    let dataChecked: any = [];
    let delData: any = [];
    if (!checkboxes?.length || checkboxes.length < 1) return true;
    checkboxes.forEach((cb: any) => {
      if (type.toLowerCase() === sendStatus.Delete.toLowerCase()) {
        dataChecked = [
          ...dataChecked,
          {
            userId: currentUserId,
            messageId: cb.value.split("_")[0],
            groupId: currentGroupId,
            transactionType: "delete",
          },
        ];
        delData = [
          ...delData,
          messageList?.filter(
            (item: any) => item?.messageId === cb.value.split("_")[0]
          )[0] ||
            newMessageList?.filter(
              (item: any) => item?.messageId === cb.value.split("_")[0]
            )[0],
        ];
      } else {
        dataChecked = [
          ...dataChecked,
          messageList?.filter(
            (item: any) => item?.messageId === cb.value.split("_")[0]
          )[0] ||
            newMessageList?.filter(
              (item: any) => item?.messageId === cb.value.split("_")[0]
            )[0],
        ];
      }
    });
    if (type.toLowerCase() === sendStatus.Delete.toLowerCase()) {
      // deleteListMessage(dataChecked);
      setMessageSelected(dataChecked);
      setShowDeleteModal(true);
    } else {
      setOpenForward({
        isOpen: true,
        dataChecked: dataChecked,
        handleCloseSelect: handleCancelActionMessgae,
      });
    }
  };

  //================= Unsend Mseeage =================
  const handleUnsendMseeage = (
    messageId: string,
    groupId: string,
    messageType: any,
    messageDetails: any
  ) => {
    handleCloseNoti();
    setOpenControl({ isOpen: false });

    setMessageSelected({ messageId, groupId, messageType, messageDetails });
    setShowUnsendModal(true);

    // confirm({
    //   title: "Are you sure to unsend message?",
    //   icon: <ExclamationCircleOutlined />,
    //   content: "",
    //   okText: "Yes",
    //   okType: "danger",
    //   cancelText: "No",
    //   onOk() {
    //     apiUnsendMseeage(messageId, groupId, messageType, messageDetails);
    //   },
    //   onCancel() {
    //     console.log("[Chat] Cancel unsend mseeage");
    //   },
    // });
  };

  const apiUnsendMseeage = async () => {
    let messageId = messageSelected?.messageId;
    let groupId = messageSelected?.groupId;
    let messageType = messageSelected?.messageType;
    let messageDetails = messageSelected?.messageDetails;

    let responseData;
    let msgBody = { messageId: messageId, groupId: groupId };
    try {
      await setNewMessageList((prevState: any) =>
        prevState.map((item: any) =>
          item?.messageId === messageId
            ? Object.assign({}, item, {
                messageStatus: sendStatus.Unsend,
              })
            : item
        )
      );
      await setMessageList((prevState: any) =>
        prevState.map((item: any) =>
          item?.messageId === messageId
            ? Object.assign({}, item, {
                messageStatus: sendStatus.Unsend,
              })
            : item
        )
      );
      if (
        messageType === messageTypes.Image ||
        messageType === messageTypes.Video ||
        messageType === messageTypes.Audio ||
        messageType === messageTypes.Sound
      )
        deleteFileInChatStorage(messageType, messageDetails);
      responseData = await apiUnsendMessage.post(msgBody);
      setStorageMessageList((prevState: any) =>
        prevState.map((item: any) =>
          item?.messageId === messageId
            ? Object.assign({}, item, {
                messageStatus: sendStatus.Unsend,
              })
            : item
        )
      );
      console.log("[Chat] Unsend message : ", responseData.status);
    } catch (error) {
      console.warn("[Chat Error] handleUnsendMseeage : ", error);
    }
  };
  //================= API Delete File in Chat =================
  const deleteFileInChatStorage = async (
    messageType: string,
    messageDetails: any
  ) => {
    console.log("[Chat] deleteFileInChatStorage ", messageType);
    if (messageType === messageTypes.Video) {
      await apiDeleteFile.post({ fileId: messageDetails.videoDetails[0].id });
    } else if (messageType === messageTypes.Audio) {
      await apiDeleteFile.post({ fileId: messageDetails.audioDetails[0].id });
    } else if (messageType === messageTypes.Sound) {
      await apiDeleteFile.post({ fileId: messageDetails.soundDetails[0].id });
    } else {
      const imageDetails = messageDetails.imageDetails;
      for (let imgItem of imageDetails) {
        await apiDeleteFile.post({ fileId: imgItem?.id });
      }
    }
  };

  const clickDeleteMessage = () => {
    let objItem = messageSelected;
    //@ts-ignore
    setNewMessageList((prevState) =>
      prevState.filter(
        //@ts-ignore
        ({ messageId: id1 }) =>
          //@ts-ignore
          !objItem.some(({ messageId: id2 }) => id2 === id1)
      )
    );
    //@ts-ignore
    setMessageList((prevState) =>
      prevState.filter(
        //@ts-ignore
        ({ messageId: id1 }) =>
          //@ts-ignore
          !objItem.some(({ messageId: id2 }) => id2 === id1)
      )
    );
    setSelect({ select: false });
    setCountSelect(0);
    apiDeleteMessage.post(objItem);
    //@ts-ignore
    setStorageMessageList((prevState) =>
      prevState.filter(
        //@ts-ignore
        ({ messageId: id1 }) =>
          //@ts-ignore
          !objItem.some(({ messageId: id2 }) => id2 === id1)
      )
    );
  };

  //================= API Delete =================
  const deleteListMessage = async (objItem: any, delData: any) => {
    console.log("[Chat] Start delete message... ");
    try {
      await setNewMessageList((prevState: any) =>
        prevState.filter(
          //@ts-ignore
          ({ messageId: id1 }) =>
            //@ts-ignore
            !objItem.some(({ messageId: id2 }) => id2 === id1)
        )
      );
      await setMessageList((prevState: any) =>
        prevState.filter(
          //@ts-ignore
          ({ messageId: id1 }) =>
            //@ts-ignore
            !objItem.some(({ messageId: id2 }) => id2 === id1)
        )
      );
      setSelect({ select: false });
      setCountSelect(0);
      await apiDeleteMessage.post(objItem);
      setStorageMessageList((prevState: any) =>
        prevState.filter(
          //@ts-ignore
          ({ messageId: id1 }) =>
            //@ts-ignore
            !objItem.some(({ messageId: id2 }) => id2 === id1)
        )
      );
      console.log("[Chat] Delete message success. ");
    } catch (error) {
      console.warn("Error deleteListMessage : ", error);
    }
  };

  const handleCopyMseeage = (messageText: string) => {
    setOpenControl({ isOpen: false });
    var dummy: any = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = messageText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };

  const handleCloseNoti = () => {
    setNotiMessage({});
    setReply(false);
  };

  useEffect(()=>{
    setNotiMessage({});
  }, [props?.group]);

  const handleCancelActionMessgae = () => {
    setSelect({ select: false });
    setCountSelect(0);
  };

  const appCtx: any = useContext(AppContext);

  useEffect(() => {
    if (
      isSelect?.type === sendStatus?.Forward &&
      countSelect === limitForward
    ) {
      console.log("[Chat] limitForward");
      setBlockSelect(true);
    }
    if (isSelect?.type === sendStatus?.Forward && countSelect < limitForward) {
      setBlockSelect(false);
    }
  }, [isSelect?.type, countSelect]);

  useEffect(() => {
    appCtx.setShowBarOnTopBarChat(false);
  }, []);

  useEffect(() => {
    if (isSelect.select) {
      appCtx.setShowBarOnTopBarChat(true);
    } else {
      appCtx.setShowBarOnTopBarChat(false);
    }
  }, [isSelect.select]);

  useEffect(() => {
    let height = 396;
    let fullHeight = 63;
    let toRemoveHeight = 0;
    if (appCtx.showBarOnTopBarChat && props?.isQuickChat) toRemoveHeight = 35;
    if (appCtx.isShowChatList === true) fullHeight = 100;
    if (appCtx.usedSearch === true) height = 320;
    console.log("[Chat] isQuickChat : ", props?.isQuickChat);
    if (isSelect?.type) {
      setHeightQuickChat(
        props?.isQuickChat
          ? "calc(" + fullHeight + "vh - " + height + "px) !important"
          : "calc(100vh - " + (265 + toRemoveHeight) + "px) !important"
      );
    } else {
      setHeightQuickChat(
        props?.isQuickChat
          ? `calc(${fullHeight}vh - ${height}px)`
          : props?.liveChat
          ? `calc(100vh - 64px)`
          : props?.conferenceChat
          ? `calc(100vh - 90px - 64px)`
          : "calc(100vh - " + (215 + toRemoveHeight) + "px)"
      );
    }
  }, [
    isSelect?.type,
    appCtx.usedSearch,
    appCtx.isShowChatList,
    appCtx.showBarOnTopBarChat,
  ]);

  const handleCountSelect = (status: any) => {
    if (status) setCountSelect(countSelect + 1);
    else setCountSelect(countSelect - 1);
  };

  const handleReplyMessage = async (messageData: any) => {
    const indexDistanceReply1 = messageList.map((object: { messageId: any; }) => object.messageId).indexOf(messageData.messageId);
    if(indexDistanceReply1 === -1){
      const indexDistanceReply2 = newMessageList.map((object: { messageId: any; }) => object.messageId).indexOf(messageData.messageId);
      messageData = Object.assign(messageData, { distanceReply : indexDistanceReply2+1 })
    }else{
      messageData = Object.assign(messageData, { distanceReply : indexDistanceReply1+newMessageList.length+1 })
    }

    handleCancelActionMessgae();
    setOpenControl({ isOpen: false });
    setReply(true);
    setNotiMessage(messageData);
    return true;
  };

  const handleSelectMessage = (status: any, defaultMessage: any) => {
    console.log("[Chat] handleSelectMessage");
    handleCloseNoti();
    setOpenControl({ isOpen: false });
    setSelect({
      select: true,
      type: status,
      default: defaultMessage,
    });
    return true;
  };

  const handlePreviewFile = (
    fileType: any,
    fileName: any,
    fileId: any,
    status: any,
    fileDetails: any,
    objMsg: any,
    index: any
  ) => {
    console.log("handlePreviewFile", fileType, fileName)
    if (isSelect.select) return;
    if (isReply) return;
    if (isPreviewFile) {
      setDataPreviewFile({});
      setPreviewFile(false);
      return;
    }
    setDataPreviewFile({
      fileType: fileType,
      fileName: fileName,
      fileId: fileId,
      status: status,
      fileDetails: fileDetails,
      objMsg: objMsg,
      index: index,
    });
    setPreviewFile(true);
  };

  const getClassHeight = () => {
    if (isGroupCommunity) {
      return styles.message_area_community;
    }
    if (!props?.isQuickChat) return "";
    if (
      appCtx.usedSearch === true &&
      appCtx.isShowChatList === false &&
      appCtx.showBarOnTopBarChat === false
    )
      return styles.message_area_height_search_100;
    else if (
      appCtx.usedSearch === true &&
      appCtx.isShowChatList === true &&
      appCtx.showBarOnTopBarChat === false
    )
      return styles.message_area_height_search;
    else if (
      appCtx.usedSearch === true &&
      appCtx.isShowChatList === false &&
      appCtx.showBarOnTopBarChat === true
    )
      return styles.message_area_height_search_100_bar;
    else if (
      appCtx.usedSearch === true &&
      appCtx.isShowChatList === true &&
      appCtx.showBarOnTopBarChat === true
    )
      return styles.message_area_height_search_bar;
    else if (
      appCtx.usedSearch === false &&
      appCtx.isShowChatList === false &&
      appCtx.showBarOnTopBarChat === false
    )
      return styles.message_area_height_100;
    else if (
      appCtx.usedSearch === false &&
      appCtx.isShowChatList === true &&
      appCtx.showBarOnTopBarChat === false
    )
      return styles.message_area_height;
    else if (
      appCtx.usedSearch === false &&
      appCtx.isShowChatList === false &&
      appCtx.showBarOnTopBarChat === true
    )
      return styles.message_area_height_100_bar;
    else if (
      appCtx.usedSearch === false &&
      appCtx.isShowChatList === true &&
      appCtx.showBarOnTopBarChat === true
    )
      return styles.message_area_height_bar;
    else return "";
  };

  const checkCommunity = () => {
    if (window.location.href.indexOf("/group-community") !== -1) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (isGroupCommunity || checkCommunity()) {
      setHeightQuickChat("calc(100vh - 210px)");
    }
  }, [isGroupCommunity]);

  useEffect(() => {
    if (!appCtx.isSearchingReply || !appCtx.currentMessageReplyId) return;
    let messageReplyId = appCtx.currentMessageReplyId;
    const element = document.getElementById(messageReplyId);
    if(element != null){
      element.classList.add(styles.animationShake)
      window.setTimeout(() => element?.focus(), 0);
        appCtx.setIsSearchingReply(false);
        appCtx.setCurrentMessageReplyId(null);
        window.setTimeout(() => element.classList.remove(styles.animationShake), 1000);
    }else{
      setTimeout(async() => {
        await searchingReply(messageReplyId)
      }, 0)
    }

  }, [searchingReplyFuncCheck,appCtx.isSearchingReply, appCtx.currentMessageReplyId])

  useEffect(() => {
    // console.log("dataPreviewFile", dataPreviewFile)
  }, [dataPreviewFile])

  const searchingReply = async (messageReplyId : any) => {
    let hide : any;
    if(props?.isQuickChat === undefined){
      message.destroy()
      hide = message.loading({ content: 'กำลังค้นหา...',style: {
        marginLeft: '20vw',
        marginTop: '20vh',
      },});
    }else{
      appContext.setIsSpinnerQuickChat(true);
    }
    
    
    const lengthData: number = messageList?.length - 1 || 0;
    const indexDistanceReply = messageList.map((object: { messageId: any; }) => object.messageId).indexOf(appCtx.currentMessageReplyIdOnPress);

  
    let msgBody: any = {
      userId: "null",
      groupId: currentGroupId,
      messageTime: messageList?.[lengthData]?.messageTime,
      messageNumber: Math.abs(messageList.length - appCtx.distanceReply)+ indexDistanceReply + 2 + 16,
    };
    let responseData: any = [];
    responseData = await apiFindMessage.post(msgBody);
    const resMessageList: any = responseData?.objData;
    const difData: any = _.differenceBy(
      resMessageList,
      messageList,
      "messageId"
    );
    
    if (difData?.length < 1) {
        appCtx.setIsSearchingReply(false);
        appCtx.setCurrentMessageReplyId(null);
    }
    if (resMessageList?.length > 0) {
      await setMessageList((prevState: any) =>
        _.uniqBy(_.concat(prevState, resMessageList), "messageId")
      );
      setSliceLength(
        (prevState: any) => prevState + (resMessageList?.length - 1)
      );
      if(document.getElementById(messageReplyId) == null){
          appCtx.setIsSearchingReply(false);
      }else{
          appCtx.setIsSearchingReply(true);
      }
      setSearchingReplyFuncRunCheck(!searchingReplyFuncCheck)
      appContext.setIsSpinnerQuickChat(false);
      setTimeout(hide, 0);
    }
  }
  const getFileType = (fileName: any) => {
    return fileName?.substr(fileName?.lastIndexOf(".") + 1, fileName.length);
  };

  const handleOnDrop = async (event: any) => {
    event.preventDefault();
    
    const files = event?.dataTransfer?.files;
    console.log("file drop : ", files);
    if ( !files || files.length < 1 ) return;
    const regexVideo = new RegExp(expVideo);
    const regexAudio = new RegExp(expAudio);
    const regexImage = new RegExp(expImgges);
    let fileName = "";
    let fileType = "";
    let messageType = "";
    for ( let item of files ) {
      fileName = item?.name;
      fileType = getFileType(fileName);
      let fileSize = item?.size;
      let mimeType = item?.type;      
      if ( fileType.match(regexVideo) ) {
        messageType = messageTypes.Video;
      } else if ( fileType.match(regexImage) ) {
        messageType = messageTypes.Image;
        let localURL = [];
        let filesImg = [];
        filesImg.push(item);
        localURL.push(item);
        if (filesImg.length === 8) {
          const tempMsgId = create_UUID();
          await pushLocalMessageFileMedia(
              messageTypes.Image,
              filesImg,
              tempMsgId,
              "",
              localURL,
              fileType,
              fileName,
              fileSize,
              mimeType
          );
          filesImg = [];
          localURL = [];
        }
        if (filesImg.length > 0) {
          const tempMsgId = create_UUID();
          await pushLocalMessageFileMedia(
              messageTypes.Image,
              filesImg,
              tempMsgId,
              "",
              localURL,
              fileType,
              fileName,
              fileSize,
              mimeType
          );
        }
        continue
      } else if ( fileType.match(regexAudio) ) {
        messageType = messageTypes.Audio;
      } else {
        messageType = messageTypes.CenterFlie;
      }
      const tempMsgId = create_UUID();
      await pushLocalMessageFileMedia(
          messageType,
          [item],
          tempMsgId,
          "",
          [URL.createObjectURL(item)],
          fileType,
          fileName,
          fileSize,
          mimeType
      );
    }
  }

  const pushLocalMessageFileMedia = async (
        messageType: any,
        messageDetails: any,
        tempMsgId: any,
        messageText: any,
        localURL: any,
        fileType: any,
        fileName: any,
        fileSize: any,
        mimeType: any
    ) => {
        console.log("pushLocalMessageFileMedia");
        const messageTime = moment(new Date()).format();
        let objDetails;
        if (messageType === messageTypes.CenterFlie)
            objDetails = {
                fileDetails: localURL,
                fileType: fileType,
                fileName: fileName,
                size: fileSize,
                mimeType: mimeType,
            };
        if (messageType === messageTypes.Image)
            objDetails = { imageDetails: localURL };
        if (messageType === messageTypes.Audio)
            objDetails = { audioDetails: localURL };
        if (messageType === messageTypes.Video)
            objDetails = { videoDetails: localURL };
        if (messageType === messageTypes.Sticker) objDetails = messageDetails;
        if (messageType === messageTypes.Sound)
            objDetails = { soundDetails: [messageDetails] };

        const tempSendImg = {
            messageStatus: sendStatus.Sending,
            userId: currentUserId,
            groupId: currentGroupId,
            messageType: messageType,
            messageText: messageText,
            messageTime: messageTime,
            messageId: tempMsgId,
            messageRefId: tempMsgId,
            messageDetails: objDetails,
            messageURLlocal: objDetails,
            stampUpload: 0,
            __v: 0,
        };
        await setNewMessageList((prevState: any) =>
            _.concat(tempSendImg, prevState)
        );
        if (
            messageType !== messageTypes.Image &&
            messageType !== messageTypes.Sticker
        ) {
            uploadCenterFile(messageType, messageDetails, tempMsgId);
            setScrollDirection({
                direct: 1,
                event: sendStatus.Update,
                objData: null,
            });
            return;
        }
        if (messageType === messageTypes.Image) {
            uploadImageFile(messageType, messageDetails, tempMsgId);
            setScrollDirection({
                direct: 1,
                event: sendStatus.Update,
                objData: null,
            });
            return;
        }
        const msgBody = {
            groupId: currentGroupId,
            messageType: messageType,
            messageText: messageText,
            messageDetails: objDetails,
            refID: tempMsgId,
        };
        setScrollDirection({
            direct: 1,
            event: sendStatus.Update,
            objData: null,
        });
        await handleSave(msgBody);
    };

  function checkUnload(e: any) {
    var confirmationMessage = "Are u sure?";
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  }

  const onUploadProgress = (progressEvent: any, tempMsgId: any) => {
      var percent = (progressEvent.loaded / progressEvent.total) * 100;
      if (percent > 100) percent = 100;
      window.addEventListener("beforeunload", checkUnload);
      percent = Math.round(percent);
      setUploadProgress((prevState: any) => {
          if (
              prevState?.length === 0 ||
              prevState.filter((item: any) => item?.tempMsgId === tempMsgId).length === 0
          ) {
              return [
                  ...prevState,
                  {
                      tempMsgId: tempMsgId,
                      progress: percent,
                  },
              ];
          } else {
              return prevState.map((item: any) =>
                  item?.tempMsgId === tempMsgId
                      ? Object.assign({}, item, {
                          progress: percent,
                      })
                      : item
              );
          }
      });
  };

  const uploadCenterFile = async (filesType: any, filesObj: any, tempMsgId: any) => {
    console.log("uploadCenterFile");
    let responseData;
    const fileDetails: any = [];
    let files =
        filesType === messageTypes.Sound ? [filesObj?.objFile] : filesObj;

    let groupId = currentGroupId;
    let hash = uuidv4();
    let axiosPromiseArray = [];
    let file = files[0];
    let temp = getClassAndType(file.name);
    let useName = await getFinalNameChat(
        temp.name_,
        temp.type_,
        groupId,
        "chat"
    );
    let blockCount = Math.ceil(file.size / chunkSize);
    let loaded = 0;
    for (let i = 0; i < blockCount; i++) {
        let CancelToken = axios.CancelToken;
        let cancel;
        const start = i * chunkSize;
        const end = Math.min(file.size, start + chunkSize);

        const form = new FormData();
        let blobSlice = File.prototype.slice;
        form.append("file", blobSlice.call(file, start, end));
        form.append("name", useName);
        //@ts-ignore
        form.append("total", blockCount);
        //@ts-ignore
        form.append("index", i);
        form.append("size", file.size);
        //@ts-ignore
        form.append("hash", hash);


        let config = {
            cancelToken: new CancelToken(function executor(c: any) {
                cancel = c;
            }),
            onUploadProgress: (progress: any) => {
                let progressTemp: any = {};
                loaded = loaded + progress.loaded;
                progressTemp.total = file.size;
                progressTemp.loaded = loaded;
                if (progress.loaded === progress.total) {
                    loaded = loaded + progress.total;
                }

                onUploadProgress(progressTemp, tempMsgId);
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: getAuthorization(),
            },
        };
        let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadSplit";
        axiosPromiseArray.push(axios.post(link, form, config));
    }

    axios
        .all(axiosPromiseArray)
        .then(() => {
            let CancelToken = axios.CancelToken;
            let cancel;

            let config = {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                }),
                onUploadProgress: (progress: any) => {
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            };

            let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/merge_chunks";

            const data = {
                size: file.size,
                name: useName + "." + temp.type_,
                total: blockCount,

                fileName: useName,
                userId: null,
                groupId: groupId,
                parentFolderId: "",
                cancelCheckOut: null,
                cancelCheckOutFileId: null,
                hash: hash,
                mimeType: file.type,
                actionType: "chat",
                convertMp3: filesType === messageTypes.Sound
            };
            axios
                .post(link, data, config)
                .then((response: any) => {
                    console.log("successful upload", response);
                    window.removeEventListener("beforeunload", checkUnload);
                    if (response?.data?.success) {
                        if (filesType === messageTypes.Sound) {
                            let objData = {
                                id: response?.data?.data.id,
                                fileName: response?.data?.data.fileName,
                                fileType: response?.data?.data.fileType,
                                group_id: response?.data?.data.group_id,
                                timeRecord: filesObj?.timeRecord,
                                mimeType: response?.data?.data.mime_type,
                                size: response?.data?.data.size_,
                            };
                            fileDetails.push(objData);
                        } else {
                            let objData = {
                                id: response?.data?.data.id,
                                fileName: response?.data?.data.fileName,
                                fileType: response?.data?.data.fileType,
                                group_id: response?.data?.data.group_id,
                                mimeType: response?.data?.data.mime_type,
                                size: response?.data?.data.size_,
                            };
                            fileDetails.push(objData);
                        }
                        const msgBody = {
                            groupId: currentGroupId,
                            messageType: filesType,
                            messageText: "",
                            messageDetails:
                                filesType === messageTypes.CenterFlie
                                    ? { fileDetails: fileDetails }
                                    : filesType === messageTypes.Video
                                        ? { videoDetails: fileDetails }
                                        : filesType === messageTypes.Audio
                                            ? { audioDetails: fileDetails }
                                            : { soundDetails: fileDetails },
                            refID: tempMsgId,
                        };
                        handleSave(msgBody);
                        console.log("Uploading success.");
                    } else {
                        if (response?.status === 400) {
                            warning({
                                title: t("Upload Failed"),
                                content: t(response.message),
                            });
                            setNewMessageList((prevState: any) =>
                                prevState.map((item: any) =>
                                    item.messageId === tempMsgId
                                        ? Object.assign({}, item, {
                                            messageStatus: sendStatus.SendFail,
                                        })
                                        : item
                                )
                            );
                            deleteFileInChatStorage(filesType, fileDetails);
                            return;
                        }
                    }
                })
                .catch(function (error: any) {
                    console.warn("Error UploadFile : ", error);
                    warning({
                        title: t("Upload Failed"),
                        content: t(error),
                    });
                    setNewMessageList((prevState: any) =>
                        prevState.map((item: any) =>
                            item.messageId === tempMsgId
                                ? Object.assign({}, item, {
                                    messageStatus: sendStatus.SendFail,
                                })
                                : item
                        )
                    );
                    return;
                })
                .finally(function () {
                    console.log("finally upload");
                    setLoadingFile(false);
                });
        })
        .catch(function (error) {
        });
  };

  const uploadImageFile = async (filesType: any, filesObj: any, tempMsgId: any) => {
    console.log("uploadImageFile");
    const fileDetails = [];
    let isSuccess = true;
    let objFile = [];
    let files =
        filesType === messageTypes.Sound ? [filesObj?.objFile] : filesObj;
    let count = 0;
    for (let item of files) {
        let data = new FormData();

        objFile.push({
            fileData: data,
            data: item,
        });
    }
    const messageGroupImageId = create_UUID();
    let messageId = "";
    for (let item of objFile) {
        let responseData: any;
        try {
            // responseData = await apiUploadFile.post(item.fileData);
            responseData = await uploadFileRequestChunkChat(
                item.data,
                currentGroupId
            );

            if (responseData?.success) {
                let objData = {
                    id: responseData.data.id,
                    fileName: responseData.data.fileName,
                    fileType: responseData.data.fileType,
                    group_id: responseData.data.group_id,
                };
                fileDetails.push(objData);
                if (count === 0) {
                    count++;
                    const msgBody = {
                        groupId: currentGroupId,
                        messageType: filesType,
                        messageGroupImageId: messageGroupImageId,
                        messageText: "",
                        messageDetails: { imageDetails: fileDetails },
                        stampUpload: objFile.length === 1 ? 1 : 0,
                        refID: tempMsgId,
                    };
                    messageId = await handleSave(msgBody);
                } else {
                    const msgBody = {
                        groupId: currentGroupId,
                        messageId: messageId,
                        messageGroupImageId: messageGroupImageId,
                        messageText: "",
                        messageDetails: { imageDetails: fileDetails },
                        stampUpload: count === objFile?.length - 1 ? objFile?.length : 0,
                        refID: tempMsgId,
                    };
                    await hendleSaveMessageImage(msgBody);
                    count++;
                }
                console.log("Uploading success.");
            } else {
                isSuccess = false;
                if (responseData?.status === 400) {
                    warning({
                        title: t("Upload Failed"),
                        content: t(responseData.message),
                    });
                    setNewMessageList((prevState: any) =>
                        prevState.map((item: any) =>
                            item.messageId === tempMsgId
                                ? Object.assign({}, item, {
                                    messageStatus: sendStatus.SendFail,
                                })
                                : item
                        )
                    );
                    deleteFileInChatStorage(filesType, fileDetails);
                    return;
                }
            }
        } catch (error) {
            isSuccess = false;
            console.warn("Error UploadFile : ", error);
            warning({
                title: t("Upload Failed"),
                content: t(""+error),
            });
            setNewMessageList((prevState: any) =>
                prevState.map((item: any) =>
                    item.messageId === tempMsgId
                        ? Object.assign({}, item, {
                            messageStatus: sendStatus.SendFail,
                        })
                        : item
                )
            );
            return;
        }
    }
    if (filesType === messageTypes.Image) return;
    const msgBody = {
        groupId: currentGroupId,
        messageType: filesType,
        messageText: "",
        messageDetails: { imageDetails: fileDetails },
        refID: tempMsgId,
    };
    if (isSuccess) await handleSave(msgBody);
  };

  const hendleSaveMessageImage = async (msgBody: any) => {
    let responseData;
    try {
        responseData = await apiSaveMessageImage.post(msgBody);
        console.log("hendleSaveMessageImage : ", responseData);
    } catch (e) {
        console.warn("Error hendleSaveMessageImage : ", e);
    }
  };

  return (
    <>
      <div className={styles.boxChat}>
        <div
          style={{
            backgroundColor: props?.community ? "" : "#FFFFFF",
            height: props?.liveOnDemandChat ? "100%" : "",
          }}
          className={styles.scollChat}
        >
          <div className={styles.boxChat}>
            {loadingData && (
              <div>
                <UIChatSkeleton />
              </div>
            )}
            <div
              ref={chatView}
              id="message_area"
              className={[styles.message_area, getClassHeight()].join(" ")}
              style={{
                maxHeight: props?.liveOnDemandChat
                  ? "calc(100% - 64px)"
                  : heightQuickChat,
                height: props?.liveOnDemandChat
                  ? "calc(100% - 64px)"
                  : heightQuickChat,
              }}
              onScroll={(e) => {
                if (isOpenControl.isOpen) setOpenControl({ isOpen: false });
                //lazy load from indexDB
                if (
                  !isOldTop &&
                  !isPullHook &&
                  chatView.current.scrollHeight + chatView.current.scrollTop <
                    800 &&
                  chatView.current.scrollHeight + chatView.current.scrollTop >
                    750
                ) {
                  if (sliceLength >= storageMessageList?.length) {
                    loadOldMessage();
                    return;
                  }
                  setIsPullHook(true);
                  let countStorage = storageMessageList?.length - sliceLength;
                  if (countStorage > limitSliceMessage) {
                    const data = storageMessageList?.slice(
                      sliceLength,
                      sliceLength + limitSliceMessage
                    );
                    setMessageList((prevState: any) =>
                      _.concat(prevState, data)
                    );
                    setSliceLength(
                      (prevState: any) => prevState + limitSliceMessage
                    );
                    setTimeout(() => {
                      setIsPullHook(false);
                    }, 300);
                  } else {
                    setMessageList((prevState: any) =>
                      _.concat(
                        prevState,
                        storageMessageList?.slice(
                          sliceLength,
                          storageMessageList?.length
                        )
                      )
                    );
                    setSliceLength(
                      (prevState: any) => prevState + countStorage
                    );
                    setTimeout(() => {
                      setIsPullHook(false);
                    }, 300);
                  }
                }
              }}
              onDrop={handleOnDrop}
              onDragOver={(e: any)=>{
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              {!loadingData &&
                newMessageList?.map((msgObj: any, index: number) => {
                  let showDate;
                  if (
                    moment(toDay).format("YYYY-MM-DD") !==
                      moment(messageList?.[0]?.messageTime).format(
                        "YYYY-MM-DD"
                      ) &&
                    index === newMessageList?.length - 1
                  ) {
                    showDate = t("Today");
                    dateBlk = "Today";
                  }
                  var invitedListStr = "";
                  if (
                    msgObj?.messageType?.toLowerCase() ===
                    messageTypes.Invited?.toLowerCase()
                  ) {
                    if (msgObj?.messageDetails) {
                      let count = 1;
                      _.each(msgObj?.messageDetails, (item) => {
                        invitedListStr += item?.firstName || item?.userId;
                        if (count < msgObj?.messageDetails?.length)
                          invitedListStr += ", ";
                        count++;
                      });
                    }
                  }
                  return (
                    <UIMessage
                      userDetail={memberData?.filter((item: any) => {
                        return item?.userId?.indexOf(msgObj?.userId) !== -1;
                      })}
                      invitedListStr={invitedListStr}
                      refNewMessage={index === 0 ? refNewMessage : null}
                      limitForward={limitForward}
                      msgObj={msgObj}
                      userId={currentUserId}
                      showDate={showDate}
                      isSelect={isSelect}
                      isReply={isReply}
                      tempMember={memberData}
                      key={
                        msgObj?.messageRefId
                          ? "new_" + msgObj?.messageRefId
                          : "new_" + msgObj?.messageId + msgObj?._id
                      }
                      setOpenControl={setOpenControl}
                      handleCloseNoti={handleCloseNoti}
                      handleCancelActionMessgae={handleCancelActionMessgae}
                      handleReSave={handleReSave}
                      handleCancelSend={handleCancelSave}
                      handleCountSelect={handleCountSelect}
                      refControl={refControl}
                      isOpenControl={isOpenControl.isOpen}
                      handlePreviewFile={handlePreviewFile}
                      isBlockSelect={isBlockSelect}
                      handleUnsendMseeage={handleUnsendMseeage}
                      handleCopyMseeage={handleCopyMseeage}
                      handleSelectMessage={handleSelectMessage}
                      handleReplyMessage={handleReplyMessage}
                      setOpenSticker={setOpenSticker}
                      setOpenRecordAudio={setOpenRecordAudio}
                      uploadProgress={uploadProgress}
                      setUploadProgress={setUploadProgress}
                      storageMessageList={storageMessageList}
                      lang={lang}
                    />
                  );
                })}

              {!loadingData &&
                messageList?.map((msgObj: any, index: number) => {
                  let showDate;
                  if (
                    moment(toDay).format("YYYY-MM-DD") ===
                    moment(msgObj?.messageTime).format("YYYY-MM-DD")
                  ) {
                    if (
                      index !== messageList?.length &&
                      moment(toDay).format("YYYY-MM-DD") !==
                        moment(messageList[index + 1]?.messageTime).format(
                          "YYYY-MM-DD"
                        ) &&
                      dateBlk !== "Today"
                    ) {
                      showDate = t("Today");
                      dateBlk = "Today";
                    }
                    if (index === messageList?.length - 1) {
                      showDate = t("Today");
                      dateBlk = "Today";
                    }
                  } else {
                    dateBlk = msgObj?.messageTime;
                    if (
                      index !== messageList?.length &&
                      moment(dateBlk).format("YYYY-MM-DD") !==
                        moment(messageList[index + 1]?.messageTime).format(
                          "YYYY-MM-DD"
                        )
                    ) {
                      if (lang === "th") {
                        let dt = moment(msgObj?.messageTime).format("MMMM D");
                        let t_month = t(dt.split(" ")[0]);
                        let t_date = dt.split(" ")[1];
                        showDate = `${t_date} ${t_month}`;
                      } else {
                        showDate = moment(msgObj?.messageTime).format("MMMM D");
                      }
                    }
                  }

                  var invitedListStr = "";
                  if (
                    msgObj?.messageType?.toLowerCase() ===
                    messageTypes.Invited?.toLowerCase()
                  ) {
                    if (msgObj?.messageDetails) {
                      let count = 1;
                      _.each(msgObj?.messageDetails, (item) => {
                        invitedListStr += item?.firstName || item?.userId;
                        if (count < msgObj?.messageDetails?.length)
                          invitedListStr += ", ";
                        count++;
                      });
                    }
                  }
                  return (
                    <UIMessage
                      userDetail={memberData?.filter((item: any) => {
                        return item?.userId?.indexOf(msgObj?.userId) !== -1;
                      })}
                      invitedListStr={invitedListStr}
                      refNewMessage={
                        index === 0 && newMessageList?.length === 0
                          ? refNewMessage
                          : null
                      }
                      limitForward={limitForward}
                      msgObj={msgObj}
                      userId={currentUserId}
                      showDate={showDate}
                      isSelect={isSelect}
                      isReply={isReply}
                      tempMember={memberData}
                      key={
                        msgObj?.messageRefId
                          ? "old_" + msgObj?.messageRefId
                          : "old_" + msgObj?.messageId + msgObj?._id
                      }
                      setOpenControl={setOpenControl}
                      handleCloseNoti={handleCloseNoti}
                      handleCancelActionMessgae={handleCancelActionMessgae}
                      handleReSave={handleReSave}
                      handleCancelSend={handleCancelSave}
                      handleCountSelect={handleCountSelect}
                      refControl={refControl}
                      isOpenControl={isOpenControl.isOpen}
                      handlePreviewFile={handlePreviewFile}
                      isBlockSelect={isBlockSelect}
                      handleUnsendMseeage={handleUnsendMseeage}
                      handleCopyMseeage={handleCopyMseeage}
                      handleSelectMessage={handleSelectMessage}
                      handleReplyMessage={handleReplyMessage}
                      setOpenSticker={setOpenSticker}
                      setOpenRecordAudio={setOpenRecordAudio}
                      uploadProgress={uploadProgress}
                      setUploadProgress={setUploadProgress}
                      storageMessageList={storageMessageList}
                      lang={lang}
                    />
                  );
                })}

              {isLoadingData && (
                <div className={styles.spinner}>
                  <div className={styles.bounce1}></div>
                  <div className={styles.bounce2}></div>
                  <div className={styles.bounce3}></div>
                </div>
              )}
            </div>
          </div>

          {isSelect.select && (
            <UIBottomButton
              type={isSelect.type}
              count={countSelect}
              handleCancelAction={handleCancelActionMessgae}
              handleSubmit={handleSubmitAction}
            />
          )}

          <div className={styles.boxFooter}>
            <UIChatToolbar
              key={"UIChatToolbar_"}
              members={members}
              loadingData={loadingData}
              setNewMessageList={setNewMessageList}
              messageList={messageList}
              isReply={isReply}
              navigator={navigator}
              notiMessage={notiMessage}
              currentUserId={currentUserId}
              currentGroupId={currentGroupId}
              handleCloseNoti={handleCloseNoti}
              isSelect={isSelect.select}
              setPageActive={setPageActive}
              handleSave={handleSave}
              chatView={chatView}
              isPreviewFile={isPreviewFile}
              setScrollDirection={setScrollDirection}
              groupInfo={props?.group}
              isOpenRecordAudio={isOpenRecordAudio}
              setOpenRecordAudio={setOpenRecordAudio}
              isOpenSticker={isOpenSticker}
              setOpenSticker={setOpenSticker}
              setOpenControl={setOpenControl}
              uploadProgress={uploadProgress}
              setUploadProgress={setUploadProgress}
              IsSocketError={IsSocketError}
            />
          </div>
        </div>

        {isOpenForward.isOpen && (
          <Modal
            visible={isOpenForward.isOpen}
            title="Forward messages"
            // style={{ top: 0 }}
            footer={null}
            onCancel={() => setOpenForward({ isOpen: false })}
          >
            <UIForwardMessages
              userId={currentUserId}
              groupId={currentGroupId}
              dataChecked={isOpenForward.dataChecked}
              handleCloseSelect={isOpenForward.handleCloseSelect}
              setOpenForward={setOpenForward}
            />
          </Modal>
        )}

        {Object.keys(notiMessage)?.length > 0 && (
          <UINotiNewMessage
            userId={notiMessage?.userId}
            username={notiMessage?.username}
            userProfile={notiMessage?.profile || ""}
            isReply={isReply}
            messageType={notiMessage?.messageType}
            messageText={notiMessage?.messageText}
            messageId={notiMessage?.messageId}
            tempMember={memberData}
            isPageActive={isPageActive}
            key={notiMessage?._id + notiMessage?.messageId}
            handleClick={handleScrollBottom}
            handleCloseNoti={handleCloseNoti}
            isQuickChat={props?.isQuickChat}
          />
        )}

        {isOpenControl.isOpen && (
          <UIMessageControl
            userId={currentUserId}
            msgObj={isOpenControl.data}
            refControl={refControl}
            handleSelectMessage={handleSelectMessage}
            handleUnsendMseeage={handleUnsendMseeage}
            handleReplyMessage={handleReplyMessage}
            handleCopyMseeage={handleCopyMseeage}
          />
        )}

        {isPreviewFile && (
          // console.log("Show video")
          <UIChatModalViewFile
            isOpen={isPreviewFile}
            data={dataPreviewFile}
            currentUserId={currentUserId}
            handleCloseViewImage={handlePreviewFile}
            setNewMessageList={setNewMessageList}
            setMessageList={setMessageList}
            setStorageMessageList={setStorageMessageList}
            setPreviewFile={setPreviewFile}
            deleteListMessage={deleteListMessage}
          />
        )}
      </div>

      <CenterConfirmModal
        cancelText={t("Cancel")}
        confirmText={t("Ok")}
        text={t("Are you sure to delete message?")}
        visible={showDeleteModal}
        onCancel={() => {
          setShowDeleteModal(false);
        }}
        onConfirm={() => {
          clickDeleteMessage();
          setShowDeleteModal(false);
        }}
      ></CenterConfirmModal>

      <CenterConfirmModal
        cancelText={t("Cancel")}
        confirmText={t("Ok")}
        text={t("Are you sure to unsend message?")}
        visible={showUnsendModal}
        onCancel={() => {
          setShowUnsendModal(false);
        }}
        onConfirm={() => {
          apiUnsendMseeage();
          setShowUnsendModal(false);
        }}
      ></CenterConfirmModal>
    </>
  );
};

export default ChatContentTab;
